import type { SortCallbackData } from '@shared/components/ui/Sort';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersSection } from '../interaction';

interface PacksHeaderProps {
  onSearch: (value: string) => void;
  onSort: (data: SortCallbackData) => void;
}

const PacksHeader: React.FC<PacksHeaderProps> = ({ onSearch, onSort }) => {
  const { t } = useTranslation('packsModule');

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-3 flex-wrap">
        <FiltersSection handleSearch={onSearch} handleSort={onSort} placeholder={t('filter.search_placeholder')} />
      </div>
    </div>
  );
};

export default PacksHeader;
